const state = {
  flow: [],
  flow_id: [],
};

export default state;
